export default {
  login: {
    title: 'Masuk',
    username: 'Nama Pengguna',
    phone: 'Nomor Telepon',
    phoneCode: 'Kode',
    email: 'Email',
    password: 'Kata Sandi',
    captcha: 'Captcha',
    loading: 'Memuat...',
    rememberMe: 'Ingat saya',
    forgotPassword: 'Lupa Kata Sandi?',
    loginButton: 'Masuk',
    contactUs: 'Hubungi Kami？',
    noAccount: 'Belum punya akun?',
    registerNow: 'Daftar',
    or: 'ATAU',
    orSignInWith: 'Atau masuk dengan',
    methodUsername: 'Nama Pengguna',
    methodPhone: 'Telepon',
    methodEmail: 'Email',
    usernameRequired: 'Nama pengguna wajib diisi',
    phoneRequired: 'Nomor telepon wajib diisi',
    emailRequired: 'Email wajib diisi',
    passwordRequired: 'Kata sandi wajib diisi',
    captchaRequired: 'Captcha wajib diisi',
    resetPassword: 'Reset Kata Sandi',
    resetStep1Hint: 'Masukkan nomor telepon atau email untuk menerima kode verifikasi.',
    useEmailInstead: 'Gunakan email',
    usePhoneInstead: 'Gunakan telepon',
    sendCode: 'Kirim Kode',
    resetStep2Hint: 'Kode verifikasi telah dikirim ke',
    verificationCode: 'Kode Verifikasi',
    verificationCodeRequired: 'Kode verifikasi wajib diisi',
    resendIn: 'Kirim ulang dalam',
    resendCode: 'Kirim Ulang Kode',
    verify: 'Verifikasi',
    resetStep3Hint: 'Atur kata sandi baru Anda.',
    newPassword: 'Kata Sandi Baru',
    confirmPassword: 'Konfirmasi Kata Sandi',
    passwordMinLength: 'Kata sandi minimal 6 karakter',
    confirmPasswordRequired: 'Silakan konfirmasi kata sandi Anda',
    passwordMismatch: 'Kata sandi tidak cocok',
    resetPasswordBtn: 'Reset Kata Sandi',
    back: 'Kembali',
    // Format validation
    emailFormat: 'Format email tidak valid',
    // Toast messages
    loginSuccess: 'Login berhasil',
    loginFailed: 'Login gagal',
    signInWithGoogle: 'Masuk dengan Google+',
    codeSent: 'Kode verifikasi terkirim',
    sendCodeFailed: 'Gagal mengirim kode',
    invalidCode: 'Kode verifikasi tidak valid',
    resetSuccess: 'Kata sandi berhasil diatur ulang',
    resetFailed: 'Gagal mengatur ulang kata sandi'
  }
};
